import { Grid, TextField, styled as materialStyled } from "@mui/material";

const smallCss = {
    "& .MuiOutlinedInput-input": {
        padding: "10px 10px 10px 10px",
        fontSize: "13px",
        minWidth: "70px",
        maxWidth: "70px",
        backgroundColor: "white",
    },
};
const CssTextField = materialStyled(TextField)(smallCss);

interface Props {
    title: string;
    value: number;
    onChange: (value: number) => void;
}

export default function QuotaItem({ onChange, title, value }: Props): JSX.Element {
    return (
        <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"}>
            <Grid item>
                <h1 style={{ fontWeight: 500, fontSize: "14px" }}>{title}</h1>
            </Grid>
            <Grid item>
                <CssTextField type="number" value={value} onChange={(e) => onChange(parseInt(e.target.value))} />
            </Grid>
        </Grid>
    );
}
